import { useNavigate } from 'react-router-dom';
import { useAddLmsTrainingReportMutation, useUpdateLmsTrainingReportMutation, useDeleteLmsTrainingReportMutation } from '../../../../../api';
import toastService from '../../../../../utils/toastService';
import { formatErrorMessage } from '../../../../../utils/errorUtils';
import { useLanguage } from '../../../../../contexts/LanguageContext';

/**
 * `TrainingReportCreateEdit` sayfasının kaydet/sil mutasyonları. Liste sayfasının veri hook'u
 * (`hooks/useTrainingReportsData.js`) ile aynı desende ayrı tutuldu — `TrainingCatalogCreateEdit`/
 * `useTrainingCatalogMutations.js` ile birebir aynı yapı. Bkz. docs/LMS-Egitim-Raporlari-API.md §3.
 */
const useTrainingReportMutations = () => {
    const { th } = useLanguage();
    const navigate = useNavigate();

    const [addMutation, { isLoading: isCreating }] = useAddLmsTrainingReportMutation();
    const [updateMutation, { isLoading: isUpdating }] = useUpdateLmsTrainingReportMutation();
    const [deleteMutation, { isLoading: isDeleting }] = useDeleteLmsTrainingReportMutation();

    const saveReport = async (payload, isEdit) => {
        try {
            if (isEdit) {
                await updateMutation(payload).unwrap();
                toastService.success(th('trainingReport.saveSuccess'), th('common.success'));
                return { success: true };
            }
            const result = await addMutation(payload).unwrap();
            toastService.success(th('trainingReport.saveSuccess'), th('common.success'));
            return { success: true, newId: result?.data?.id ?? null };
        } catch (err) {
            toastService.error(formatErrorMessage(err) || th('trainingReport.saveError'), th('common.error'));
            return { success: false };
        }
    };

    const deleteReport = async (id) => {
        try {
            await deleteMutation(id).unwrap();
            toastService.success(th('trainingReport.deleteSuccess'), th('common.success'));
            navigate('/learning-management-system/training-report');
            return true;
        } catch (err) {
            toastService.error(formatErrorMessage(err) || th('trainingReport.deleteError'), th('common.error'));
            return false;
        }
    };

    return {
        saveReport,
        deleteReport,
        isCreating,
        isUpdating,
        isDeleting
    };
};

export default useTrainingReportMutations;
